{
  "cycle.entite.organisation_cles_signature": "Organisation signing keys",
  "cycle.entite.organisation_webhook_livraisons": "Organisation webhook deliveries",
  "cycle.entite.organisation_webhooks": "Organisation webhooks",
  "journalAudit.action.org.signing_key.registered": "Signing key registered",
  "journalAudit.action.org.signing_key.removed": "Signing key removed",
  "journalAudit.action.org.signing_key.replaced": "Signing key replaced",
  "journalAudit.action.org.webhook.created": "Organisation webhook created",
  "journalAudit.action.org.webhook.deleted": "Organisation webhook deleted",
  "journalAudit.action.org.webhook.disabled": "Organisation webhook disabled",
  "journalAudit.action.org.webhook.enabled": "Organisation webhook enabled",
  "journalAudit.action.org.webhook.secret_rotated": "Webhook signing secret rotated",
  "journalAudit.action.org.webhook.updated": "Organisation webhook updated"
}
